<h1 class="font-header font-(--font-weight-header) text-xl mt-5">{{ title() }}</h1>

<div class="lg:flex hidden flex-row gap-2 mt-3">
  <div class="flex flex-row gap-2">
    <app-filters-item label="Sort By" class="w-full text-nowrap">
      <app-select
        label="Sort By"
        class="w-48 text-nowrap"
        [(value)]="filteringService.sort"
        [options]="sortByOptions"
      />
    </app-filters-item>
  </div>

  <button
    type="button"
    class="flex flex-row gap-2 rounded-md ml-auto px-3 text-sm hover:bg-gray-900/5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900/30 dark:focus-visible:outline-white/30 items-center dark:hover:bg-white/5 z-10 cursor-pointer"
    [style.display]="filteringService.hasFilters() === false ? 'none' : 'flex'"
    (click)="filteringService.resetFilters()"
  >
    <svg class="fill-gray-900 dark:fill-white h-4 w-4" viewBox="0 -960 960 960">
      <path
        d="M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440h80q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720h-6l62 62-56 58-160-160 160-160 56 58-62 62h6q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-440q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80Z"
      />
    </svg>

    Clear Filters
  </button>
</div>

@if (
  filteringService.dreamHomes() &&
  listingsService.sidebarListings().length === 0 &&
  stateService.initialListingsLoaded() &&
  !stateService.isLoading()
) {
  <div class="mt-6 rounded-lg bg-white dark:bg-gray-900/20 p-5 flex flex-col gap-3">
    <h2 class="font-header font-(--font-weight-header) text-lg">
      {{
        filteringService.userSavedListingIds()?.length
          ? `It
    looks
    like your saved home${filteringService.userSavedListingIds()?.length === 1 ? ' is' : 's are'} no longer on the market.`
          : 'No Dream Homes yet'
      }}
    </h2>

    <p class="text-sm text-gray-600 dark:text-gray-300">
      Tap the heart on any listing to save it here.
    </p>

    <div class="flex gap-2">
      <button
        type="button"
        class="rounded-md px-3 py-2 text-sm text-white bg-primary-500 hover:bg-primary-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
        (click)="filteringService.dreamHomes.set(false)"
      >
        Browse all homes
      </button>
    </div>
  </div>
}

<div class="grid grid-cols-1 min-[550px]:grid-cols-2 md:grid-cols-1 gap-4 2xl:grid-cols-2 mt-3">
  @if (
    !listingsService.sidebarListings().length &&
    stateService.initialListingsLoaded() &&
    !filteringService.dreamHomes() &&
    !stateService.isLoading()
  ) {
    <app-no-results [reason]="listingsService.noResultsReason()" class="col-span-2 mt-10" />
  } @else {
    @if (stateService.isLoading() || !stateService.initialListingsLoaded()) {
      <div class="col-span-2 flex flex-col items-center gap-4 mt-10">
        <p class="text-gray-600 dark:text-gray-300">Loading your listings...</p>
      </div>
    } @else {
      @for (listing of listingsService.sidebarListings(); track listing.id; let i = $index) {
        <app-listing-card
          class="self-start"
          [initialRender]="i < 6"
          [listing]="listing"
          (mouseenter)="onEnter(listing)"
          (mouseleave)="onLeave()"
        />
      }

      <div homefinderInViewport (visibilityChange)="loadMore($event)" class="mb-2"></div>
    }
  }
  @if (
    filteringService.relatedModels().length > 0 &&
    !filteringService.search() &&
    !stateService.isLoading() &&
    stateService.initialListingsLoaded()
  ) {
    <app-suggested-models class="col-span-full mt-10" />
  }
</div>
